import apiCarga from "@/services/vex/apiCarga";

async function versaoDeDadosServidor() {
    let token = JSON.parse(localStorage.getItem("enterprise")).name;
    let uri = `/empresas/${token}/versao-dados`;
    const response = await apiCarga.get(uri, {timeout: 10000});

    // Esse endpoint só retorna json com status no caso de erro
    const ERR = response.data?.status === "ERR";

    if(!ERR)
        return JSON.parse(response.data);
    else
        throw new Error(response.data.message);
}

export default versaoDeDadosServidor;
